import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import moment from "moment";
import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ParametresInstance } from "../../../../../Controls/Parameters";

@Component
export default class TableauAnnulationTerminee extends Vue {
	@Prop()
	public absencesAnnulationTerminee: AbsenceSalarieDto[] = [];

	public estAnnule(absence: AbsenceSalarieDto): boolean {
		return absence.Etat == EtatAbsencesEnum.Annule;
	}

	public getLibelleEtat(absence: AbsenceSalarieDto): string {
		let libelleEtat = ParametresInstance.getLibelleEtatAbsence(absence.Etat);
		libelleEtat = libelleEtat[0].toUpperCase() + libelleEtat.slice(1);

		if ((absence.Etat === EtatAbsencesEnum.Valide ||
			absence.Etat === EtatAbsencesEnum.Annule ||
			absence.Etat === EtatAbsencesEnum.Refuse) &&
			absence.DateValidation != undefined) {
			libelleEtat = libelleEtat + " le " + moment(absence.DateValidation).format("DD/MM/YYYY");
		}

		return libelleEtat;
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/tableaux/tableauAnnulationTerminee/tableauAnnulationTerminee.ts